import React from "react";
import { EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { EditVideoTechnicalAside } from "./EditVideoTechnicalAside";

export interface EditVideoTechnicalButtonAsideProps {
    fileRecordId: string;
    isDisabled: boolean;
    isLabeled?: boolean;
}

export const EditVideoTechnicalButtonAside: React.FunctionComponent<EditVideoTechnicalButtonAsideProps> = (
    props: EditVideoTechnicalButtonAsideProps
) => {
    const { fileRecordId, isLabeled, isDisabled } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                testId="edit-technical"
                disabled={isDisabled}
            />
            <EditVideoTechnicalAside
                fileRecordId={fileRecordId}
                isOpen={isOpen}
                onCancel={onClose}
                onSubmit={onClose}
            />
        </AuthorizationWrapper>
    );
};
